import {
  ChangeDetectionStrategy,
  Component,
  OnChanges,
  SimpleChanges,
  forwardRef,
  EventEmitter,
  Output,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => InputComponent),
  //     multi: true
  //   }
  // ]
})
export class InputComponent {
  @Input() label: string | [''] = '';
  @Input() disabled : boolean = false
  @Input() placeholder: string = '';
  @Input() type: string = '';
  @Input() inputData: string = '';

  @Output() dataEvent = new EventEmitter<string>();
  @Output() enterPressed = new EventEmitter<void>();

  // inputData: string = "";

  onKeyUp(event: any) {
    const inputData = event.target.value;
    this.dataEvent.emit(inputData);
  }
  onEnter() {
    this.enterPressed.emit();
  }

  // @Output() loginEvent = new EventEmitter<{ email: string}>();
}
